import { createSlice } from '@reduxjs/toolkit';
import eyetestApi from './eyetestApi';

const dataSlice = createSlice({
    name: 'eyetest',
    initialState: {
        error: null,
        count: [],
        posList: [],
        opticianList: [],
        recentListData: [],
        listData: {},
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                eyetestApi.endpoints.recentEyetestList.matchFulfilled,
                (state, action) => {
                    state.recentListData = action.payload; // Save the new data to the state
                }
            )
            .addMatcher(
                eyetestApi.endpoints.eyetestList.matchFulfilled,
                (state, action) => {
                    state.listData = action.payload; // Save the new data to the state
                }
            )
            .addMatcher(
                eyetestApi.endpoints.eyetestList.matchRejected,
                (state, action) => {
                    state.error = action.error.message;
                }
            )
            .addMatcher(
                eyetestApi.endpoints.eyetestCount.matchFulfilled,
                (state, action) => {
                    state.count = action.payload; // Save the new data to the state
                }
            )
            .addMatcher(
                eyetestApi.endpoints.eyetestCount.matchRejected,
                (state, action) => {
                    state.error = action.error.message;
                }
            )
            .addMatcher(
                eyetestApi.endpoints.eyetestCount.matchFulfilled,
                (state, action) => {
                    state.count = action.payload; // Save the new data to the state
                }
            );
    },
});

export default dataSlice.reducer;
